// extracted by mini-css-extract-plugin
module.exports = {"grid":"transaction-list-item_grid__2OFiS","grow":"transaction-list-item_grow__yef7q"};